module.exports = __webpack_public_path__ + "img/anjo_chakras.ee8a54f9.jpeg";